import PropTypes from 'prop-types';

export const ErrorPropType = PropTypes.shape({
  filename: PropTypes.string,
  code: PropTypes.number,
  details: PropTypes.oneOfType([
    PropTypes.shape({
      message: PropTypes.string,
      rowIndex: PropTypes.number,
      rowPeriod: PropTypes.string,
      correctPeriod: PropTypes.string,
      companyCode: PropTypes.string,
    }),
    PropTypes.arrayOf(PropTypes.shape({
      expected: PropTypes.string,
      found: PropTypes.string,
    })),
  ]),
});

export const ValuePropType = PropTypes.shape({
  filename: PropTypes.string,
});

export const JobPropType = PropTypes.shape({
  createdOn: PropTypes.string.isRequired,
  finishedOn: PropTypes.string,
  jobId: PropTypes.string.isRequired,
  jobType: PropTypes.string.isRequired,
  returnedError: ErrorPropType,
  returnedValue: ValuePropType,
  startedProcessedOn: PropTypes.string,
  status: PropTypes.string.isRequired,
  progress: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      percentage: PropTypes.number,
      message: PropTypes.string,
    }),
  ]),
  notificationSeenFlag: PropTypes.oneOf(['Y', 'N']),
});

export const JobConfigPropType = {
  type: PropTypes.string.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  progressBarText: PropTypes.string,
  displayName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]).isRequired,
};

export type JobConfig = {
  type: string,
  successMessage?: string,
  errorMessage?: string,
  progressBarText?: string,
  returnsFile?: boolean,
  displayName: string | ((payload: any) => string),
  page?: string,
}
